import {FC} from 'react'
import {
  getInvoiceFieldRule,
  InvoiceRulesV79,
  isInvoiceFieldReadOnly,
  isInvoiceFieldVisible,
} from '../../core/invoiceRulesV79'
import {FieldHelpLabel} from '../../../../../../../_metronic/helpers/components/FieldHelp'

type Props = {
  rules?: InvoiceRulesV79
  note1: string
  setNote1: (value: string) => void
  note2: string
  setNote2: (value: string) => void
  readOnly?: boolean
}

const InvoiceNotesV79Fields: FC<Props> = ({
  rules,
  note1,
  setNote1,
  note2,
  setNote2,
  readOnly,
}) => {
  const note1Rule = getInvoiceFieldRule(rules, 'nti1')
  const note2Rule = getInvoiceFieldRule(rules, 'nti2')
  const showNote1 = isInvoiceFieldVisible(rules, 'nti1', false)
  const showNote2 = isInvoiceFieldVisible(rules, 'nti2', false)

  if (!showNote1 && !showNote2) return null

  return (
    <div className='col-12 mt-5' data-testid='invoice-v79-notes'>
      <div className='row g-5' data-testid='invoice-v79-notes-layout'>
        {showNote1 && (
          <div className='col-12' data-testid='invoice-nti1-row'>
            <label className='form-label fw-bold text-gray-900' htmlFor='invoice-nti1'>
              <FieldHelpLabel label='یادداشت تکمیلی ۱' helpKey='header.nti1' />
            </label>
            <input
              id='invoice-nti1'
              className='form-control'
              maxLength={note1Rule?.maxLength || 30}
              value={note1}
              disabled={readOnly || isInvoiceFieldReadOnly(rules, 'nti1')}
              onChange={(event) => setNote1(event.target.value)}
            />
          </div>
        )}
        {showNote2 && (
          <div className='col-12' data-testid='invoice-nti2-row'>
            <label className='form-label fw-bold text-gray-900' htmlFor='invoice-nti2'>
              <FieldHelpLabel label='یادداشت تکمیلی ۲' helpKey='header.nti2' />
            </label>
            <input
              id='invoice-nti2'
              className='form-control'
              maxLength={note2Rule?.maxLength || 30}
              value={note2}
              disabled={readOnly || isInvoiceFieldReadOnly(rules, 'nti2')}
              onChange={(event) => setNote2(event.target.value)}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export {InvoiceNotesV79Fields}
